<template>
  <div class="row" >
  <div class="col-md-2 btn-today">
    <a class="btn btn-success" v-if="show" v-on:click="today" role="button">Today</a>
  </div>
  <div class="col-md-8">
  <button class="prev" v-on:click="decrement"><i class="fa fa-chevron-left"></i></button>
    <datepicker :disabled="state.disabled" v-model="internalValue" :format="state.format"  ui-datepicker-calendar="hide" class="datepicker"></datepicker>
    <button  class="next" v-on:click="increment"><i class="fa fa-chevron-right"></i></button>
    </div>
   <!-- <div class="col-md-2 fb-share-button" data-href="http://demo.drishti.live" data-layout="button_count" data-size="large" data-mobile-iframe="true"><a class="fb-xfbml-parse-ignore" target="_blank" href="https://www.facebook.com/sharer/sharer.php?u= src=sdkpreparse"></a></div> -->
<social-sharing url="http://demo.drishti.live" title="Average Hourly  Pollution Data of Kathmandu" inline-template>
  <div class="col-md-2 fb-share-button">
      <network network="facebook">
      <button> <i class="fa fa-facebook"></i>Share</button>
       
      </network>
    </div>
   </social-sharing> 
  </div> <!-- row -->
</template>
<script>

import Vue from 'vue'
import Datepicker from 'vuejs-datepicker';
import * as moment from 'moment-timezone';
import SocialSharing from 'vue-social-sharing'
  Vue.use(SocialSharing)

var state = {
    disabled: {
        from: new Date(), // Disable all dates up to specific date
    },
    format : "yyyy-MM-dd"
}

export default {
  name: 'mydatepicker',
  props: ['value'],
  data(){
    return {
      show:false,
      state:state,
      internalValue: moment().format('MM/DD/YYYY')
    }
  },

  watch: {
    internalValue: function() {
      this.$emit('input', this.internalValue);
      this.checkToday(this.internalValue);
     
    }
  },
  //  SocialSharing: {
  //   title: "Average Hourly  Pollution Data of Kathmandu"   
  // },
  methods : {
   increment(){
      var  dateValue = new Date(this.internalValue)
      var now=this.parseDate(new Date())+' 00:00:00'
      var str2=Date.parse(now)
      var dateFormat = this.parseDate(dateValue)+' 23:59:59'
      var str=Date.parse(dateFormat)
     if(str >= str2)
     {
      
     }
     else{
     str /=1000
      str +=120
      var newstr = new Date(str * 1000)
      this.internalValue=newstr
      this.checkToday(this.internalValue)
     
     }
      
     
   },
   decrement(){
     var  dateValue = new Date(this.internalValue)
      var dateFormat = this.parseDate(dateValue)+' 00:00:00'
      var str=Date.parse(dateFormat)
      str /=1000
      str -=60
      var newstr = new Date(str * 1000)
      this.internalValue=newstr
      this.checkToday(this.internalValue)
      
   },
   today(){
    var  dateValue = new Date()
      this.internalValue=dateValue
      this.checkToday(this.internalValue)
      
   },
   parseDate:function(dateValue){
        var year = dateValue.getFullYear()+""
        var month = ('0' + (dateValue.getMonth()+1)).slice(-2)+""
        var day = ('0' + dateValue.getDate()).slice(-2)+""
        var dateFormat = year + "-" + month + "-" + day
        return dateFormat
      },
    checkToday:function(internalValue){
      if(moment(internalValue).format('MM/DD/YYYY')==moment().format('MM/DD/YYYY')){
        this.show=false
      }else{
        this.show=true
      }
    }
   },
  
  
  components: {
      Datepicker
  }
}
</script>

<style>
/*body {
    font-family: 'Helvetica Neue Light', Helvetica, sans-serif;
    padding: 1em 2em 2em;
}*/

body{
  font-family:'Lato', sans-serif;
}
input, select {
    padding: .75em .5em;
    font-size: 100%;
    border: 1px solid #ccc;
    /*border-color: transparent;
      background: transparent;*/
    /*width: 100%*/
}
.calendar{
  /*display: none;*/
}

/*.input {
  'display': 'inline-block';
  'padding': '6px';
  'line-height': '22px';
  'font-size': '16px';
  'border': '2px solid #fff';
  'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)';
  'border-radius': '2px';
  'color': '#5F5F5F';
}*/
select {
    height: 2.5em;
}

.example {
    background: #f2f2f2;
    border: 1px solid #ddd;
    padding: 0em 1em 1em;
    margin-bottom: 2em;
}

code,
pre {
    margin: 1em 0;
    padding: 1em;
    border: 1px solid #bbb;
    display: block;
    background: #ddd;
    border-radius: 3px;
}

.settings {
    margin: 2em 0;
    padding: 0 1.5em 1.5em;
    border-top : 1px solid #bbb;
    background: #eee;
}

/*h5 {
    font-size:100%;
    padding: 0;
}*/

.form-group {
    margin-bottom: 1em;
}

.form-group label {
    font-size: 80%;
    display: block;
}

.calendar {
    position: absolute;
    z-index: 100;
    background: #fff;
    width: 300px;
    border: 1px solid #ccc;
    left: 0;
    right: 0;
    margin: 0 auto;
}
.next, .prev{
      display:inline-block;
      padding: 0px;
      border: none;
      background:transparent;
    }

.next i, .prev i{
  font-size: 20px;
  color: #333333;
}    

.datepicker.datepicker input{
  text-align: center;
  background:transparent;
  color: #333333;
  border:0px;
  font-family:"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif;
  width:215px;
  font-size:28px;
}
.btn-today {
  margin-top: 20px;
}
.fb-share-button{
  margin-top: 20px;
  text-align: right;
  
}
.fb-share-button button{
   border: 1px solid #dddddd;
    border-radius: 6px;
    background: #fff;
    font-size: 14px;
    font-weight: bold;
    color: #fff;
    background: #205fa5; 
}
.fb-share-button span{
  color:#205fa5;
}
:focus{
  outline:0;
}
</style>



// WEBPACK FOOTER //
// Datepicker.vue?4ab9db3f